<div class="rkt-form-field-wrapper">
  <div class="rkt-form-field" [class.has-error]="isMaximumValue || isMinimumValue">
    <input
      type="text"
      class="rkt-form-input"
      [class.is-invalid]="isMaximumValue || isMinimumValue"
      [formControl]="valueField"
      id="limitValue"
      [prefix]="currencySign + ' '"
      mask="separator.2"
      thousandSeparator=","
      [placeholder]="currencySign + '0.00'"
      (ngModelChange)="onChange($event)"
      (blur)="onBlur()"
    />

    @if (isMaximumValue) {
      <div class="rkt-form-field-invalid-feedback">Transaction amount limit must be less or equal to {{ maxLimitsType[limitType] }}.</div>
    }

    @if (isMinimumValue) {
      <div class="rkt-form-field-invalid-feedback">Transaction amount limit must be greater than {{ currencySign }}0.00</div>
    }
  </div>
</div>
